import { Palette } from 'lucide-react';
import ServiceHeader from '../../components/services/ServiceHeader';
import ServiceFeatures from '../../components/services/sections/ServiceFeatures';
import ServiceBenefits from '../../components/services/sections/ServiceBenefits';
import ServiceSteps from '../../components/services/sections/ServiceSteps';
import { canvaFeatures } from '../../data/services/canvaPro';
import { colors } from '../../styles/theme';

const benefits = [
  {
    value: "100%",
    label: "Gratuit pour les étudiants"
  },
  {
    value: "Illimité",
    label: "Accès à toutes les fonctionnalités"
  },
  {
    value: "Pour les premiums",
    label: "Support prioritaire inclus"
  }
];

const steps = [
  {
    title: "Inscrivez-vous sur FRANCE STUDENT",
    description: "Créez votre compte étudiant en quelques clics"
  },
  {
    title: "Vérifiez votre statut étudiant",
    description: "Téléchargez votre carte étudiante ou certificat de scolarité"
  },
  {
    title: "Activez votre compte Canva Pro+",
    description: "Recevez vos identifiants par email en quelques secondes seulement"
  }
];

const CanvaProPage = () => {
  const handleActivate = () => {
    window.location.href = 'https://my.francestudent.org/store/canva';
  };

  return (
    <div>
      <ServiceHeader
        title="Canva Pro+"
        description="Libérez votre créativité avec un accès complet à Canva Pro+. Créez des designs professionnels pour vos projets académiques et personnels."
        icon={<Palette className="w-8 h-8 text-white" />}
        color={colors.secondary}
        imageUrl="https://static-cse.canva.com/blob/1825140/voeux-professionnels-originaux.jpg"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <ServiceFeatures
          title="Fonctionnalités Premium"
          features={canvaFeatures}
          color={colors.secondary}
        />

        <ServiceBenefits
          title="Avantages Étudiants"
          benefits={benefits}
          color={colors.secondary}
        />

        <ServiceSteps
          title="Comment en bénéficier"
          steps={steps}
          color={colors.secondary}
          ctaText="Activer mon compte Canva Pro+"
          onCtaClick={handleActivate}
        />
      </div>
    </div>
  );
};

export default CanvaProPage;
